module.exports = __webpack_public_path__ + "static/media/covid-act-now-logo-dark.5e3dfce5.svg";